import React from "react";
import EditButton from "./Link";
import { NumberFormatOptions } from "i18n/helpers";
import { injectIntl } from "react-intl";

export default injectIntl(
  ({
    CPM,
    cost,
    exposure,
    name,
    id,
    isEmptyStat,
    intl: { formatNumber },
    isSingle
  }) => (
    <div className="data-item-container">
      <div className="data-item-panel">
        <div className="row">
          {!isSingle && (
            <div className="data-item-heading col-xs-4">
              <h3 className="data-item-title">{name || id}</h3>
              <div className="detail-link">
                <EditButton id={id} />
                {isEmptyStat && (
                  <small>За выбранный период статистика отсутствует</small>
                )}
              </div>
            </div>
          )}
          <div
            className={`data-item-body ${isSingle
              ? "col-xs-12 l-b-0"
              : "col-xs-8"}`}
          >
            <div className="data-item data-item-exposure">
              <span>Показы</span>
              <span>{(exposure && formatNumber(exposure)) || "—"}</span>
            </div>
            <div className="data-item data-item-cpm">
              <span>CPM</span>
              <span>
                {(CPM && formatNumber(CPM, NumberFormatOptions)) || "—"}
              </span>
            </div>
            <div className="data-item data-item-cost">
              <span>Доход</span>
              <span>
                {(cost && formatNumber(cost / 1e5, NumberFormatOptions)) || "—"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
);
